import React, { useEffect } from 'react'
import useForm from 'react-hook-form'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouter } from 'react-router-dom'
import { faFolder, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container
} from 'reactstrap'
import PropTypes from 'prop-types'
import { fetchCategory, updateCategory } from 'redux/actions/categories'
import CategoryForm from 'components/Categories/form'
import BackButton from 'components/BackButton'

const EditCategory = ({ fetchCategory, updateCategory, form, loading, history, match }) => {
  const { register, reset, setError, handleSubmit, errors } = useForm()
  useEffect(() => {
    fetchCategory(match.params.id)
  }, [fetchCategory, match])

  useEffect(() => {
    reset(form)
  }, [form, reset])

  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faFolder} className="mr-1"/> Editar Categoría<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to={`/admin/categories/${match.params.id}`}
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Cancelar
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {!loading && (
                <CategoryForm
                  onSubmit={handleSubmit(params => updateCategory({ ...params }, history, setError))}
                  history={history}
                  register={register}
                  errors={errors}
                />
              )}
              {loading && (
                <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToProps = ({ categories: { form, loadingCategory } }) => ({
  form,
  loading: loadingCategory
})

const mapDispatchToProps = dispatch => ({
  fetchCategory: id => dispatch(fetchCategory(id)),
  updateCategory: (values, history) => dispatch(updateCategory(values, history)),
})

EditCategory.propTypes = {
  form: PropTypes.shape({
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  loading: PropTypes.bool,
  fetchCategory: PropTypes.func.isRequired,
  updateCategory: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    }).isRequired
  }).isRequired,
}

EditCategory.defaultProps = {
  loading: false,
  form: {
    address: '',
    name: '',
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditCategory))
